import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { AssetOverviewTab } from '@/components/features/assets/components/AssetOverviewTab';
import { Skeleton } from '@/components/ui/skeleton';

function AssetsPageLoading() {
  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="hidden md:block">
        <Skeleton className="h-8 w-48 mb-2" />
        <Skeleton className="h-4 w-96" />
      </div>
      <div className="space-y-4">
        <Skeleton className="h-10 w-full" />
        <div className="space-y-4">
          <Skeleton className="h-64 w-full" />
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/assets')({
  pendingComponent: AssetsPageLoading,
  component: () => (
    <Suspense fallback={<AssetsPageLoading />}>
      <AssetsPage />
    </Suspense>
  ),
});

function AssetsPage() {
  const { t } = useTranslation();

  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="hidden md:block">
        <h1 className="text-2xl font-bold tracking-tight">{t('assets.title')}</h1>
        <p className="text-sm text-muted-foreground">{t('assets.description')}</p>
      </div>

      <AssetOverviewTab />
    </div>
  );
}
